export const REDUX_STORE_HOME = 'cloudwatch-monitoring'
export const CLOUDWATCH_MONITORING_ERROR = 'Unable to fetch CloudWatch monitoring data'